import request from '@/utils/request'

// 热度是辅助信息，请求失败不能打断页面导航或弹出全局错误。
export function getMenuHeat() {
  return request({ url: '/system/menu/heat', method: 'get', timeout: 5000, silentError: true })
}

export function recordMenuVisit(menuId) {
  return request({ url: '/system/menu/visit', method: 'post', data: { menuId }, timeout: 5000, silentError: true })
}
